import useAppUserPermissions from 'hooks/useAppUserPermissions';

const useCalendarBodySelectionAllowed = () => {
  const permissions = useAppUserPermissions();
  return permissions.includes('Leads:Create');
};

export default useCalendarBodySelectionAllowed;
